var oldStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.40af531c533a078c59c5e6c0dbac03d9.js */ "./node_modules/.federation/entry.40af531c533a078c59c5e6c0dbac03d9.js");
	}
	return oldStartup();
};